import * as React from "react";
const SVGComponentFooterChats = (props) => (
  <svg
    width={512}
    height={484}
    viewBox="0 0 512 484"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="3ea3b537">
      <g id="a325bec8">
        <g id="96667b7a">
          <path
            id="b8b6bbda"
            d="M221.795 117.128C203.229 117.128 188.125 132.233 188.125 150.798C188.125 169.363 203.23 184.468 221.795 184.468C240.36 184.468 255.465 169.365 255.465 150.798C255.466 132.233 240.361 117.128 221.795 117.128ZM221.795 168.435C212.07 168.435 204.158 160.523 204.158 150.798C204.158 141.073 212.07 133.161 221.795 133.161C231.52 133.161 239.432 141.073 239.432 150.798C239.432 160.523 231.52 168.435 221.795 168.435Z"
            fill="black"
            stroke="black"
            strokeWidth={0.002}
          />
        </g>
      </g>
      <g id="e6f11a4f">
        <g id="97c83d35">
          <path
            id="115f411c"
            d="M127.733 117.128C109.167 117.128 94.063 132.233 94.063 150.798C94.063 169.363 109.168 184.468 127.733 184.468C146.298 184.468 161.403 169.365 161.403 150.798C161.403 132.233 146.298 117.128 127.733 117.128ZM127.733 168.435C118.008 168.435 110.096 160.523 110.096 150.798C110.096 141.073 118.008 133.161 127.733 133.161C137.458 133.161 145.37 141.073 145.37 150.798C145.37 160.523 137.458 168.435 127.733 168.435Z"
            fill="#222B63"
            stroke="#222B63"
            strokeWidth={0.002}
          />
        </g>
      </g>
      <g id="ab86a879">
        <g id="83814ef5">
          <path
            id="9528a34b"
            d="M512 313.27C512 273.129 494.074 235.808 461.524 208.185C458.148 205.321 453.088 205.736 450.225 209.111C447.36 212.487 447.774 217.546 451.15 220.41C480.051 244.938 495.968 277.915 495.968 313.27C495.968 351.443 476.928 387.432 443.728 412.006C441.183 413.89 439.985 417.097 440.672 420.188L449.357 459.269L408.167 434.554C406.162 433.352 403.729 433.083 401.51 433.822C385.07 439.296 367.762 442.072 350.064 442.072C269.613 442.072 204.16 384.292 204.16 313.27C204.16 242.248 269.613 184.468 350.064 184.468C376.497 184.468 402.386 190.774 424.935 202.707C428.846 204.777 433.7 203.284 435.77 199.371C437.842 195.458 436.347 190.607 432.434 188.536C407.584 175.387 379.101 168.435 350.064 168.435C349.709 168.435 349.357 168.445 349.004 168.447C349.34 164.474 349.53 160.479 349.53 156.499C349.53 70.349 271.131 0.261993 174.766 0.261993C78.401 0.261993 0 70.35 0 156.499C0 174.43 3.369 192.014 10.014 208.764C11.709 213.039 16.827 215.027 20.97 213.019C24.696 211.213 26.444 206.699 24.917 202.852C19.021 187.992 16.032 172.397 16.032 156.499C16.032 79.19 87.238 16.295 174.763 16.295C262.288 16.295 333.495 79.19 333.495 156.499C333.495 160.752 333.272 165.025 332.841 169.255C257.932 176.371 198.118 229.352 189.267 296.112C184.459 296.497 179.593 296.702 174.764 296.702C145.849 296.702 117.54 289.757 92.896 276.62C90.539 275.363 87.709 275.363 85.352 276.621L48.631 296.205L61.604 261.61C62.743 258.569 61.939 255.142 59.562 252.93C51.926 245.816 45.12 237.98 39.331 229.638C36.806 226.003 31.812 225.097 28.174 227.623C24.537 230.147 23.634 235.142 26.158 238.78C31.595 246.615 37.831 254.042 44.741 260.915L26.164 310.456C23.631 317.21 31.049 323.756 37.443 320.344L89.181 292.751C115.218 305.839 144.71 312.737 174.764 312.737C179.213 312.737 183.694 312.582 188.139 312.282C188.137 312.612 188.125 312.94 188.125 313.272C188.125 393.134 260.769 458.107 350.062 458.107C368.22 458.107 386.02 455.44 403.031 450.174L457.102 482.619C463.03 486.171 470.545 480.722 469.052 474.005L457.43 421.705C492.178 394.183 512 354.94 512 313.27Z"
            fill="black"
            stroke="black"
            strokeWidth={0.002}
          />
        </g>
      </g>
      <g id="48a5d978">
        <g id="04be50ab">
          <path
            id="487944bd"
            d="M298.756 279.6C280.19 279.6 265.086 294.705 265.086 313.27C265.086 331.835 280.191 346.94 298.756 346.94C317.321 346.94 332.426 331.835 332.426 313.27C332.426 294.705 317.321 279.6 298.756 279.6ZM298.756 330.907C289.031 330.907 281.119 322.995 281.119 313.27C281.119 303.545 289.031 295.633 298.756 295.633C308.481 295.633 316.393 303.546 316.393 313.27C316.393 322.995 308.481 330.907 298.756 330.907Z"
            fill="#785AF0"
            stroke="#785AF0"
            strokeWidth={0.002}
          />
        </g>
      </g>
      <g id="07770dc5">
        <g id="b89b8869">
          <path
            id="cdf96739"
            d="M401.37 279.6C382.804 279.6 367.7 294.705 367.7 313.27C367.7 331.835 382.805 346.94 401.37 346.94C419.936 346.94 435.04 331.835 435.04 313.27C435.04 294.705 419.935 279.6 401.37 279.6ZM401.37 330.907C391.645 330.907 383.733 322.995 383.733 313.27C383.733 303.545 391.645 295.633 401.37 295.633C411.095 295.633 419.007 303.545 419.007 313.27C419.007 322.995 411.094 330.907 401.37 330.907Z"
            fill="black"
            stroke="black"
            strokeWidth={0.002}
          />
        </g>
      </g>
    </g>
  </svg>
);
export default SVGComponentFooterChats;
